import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogModule,
} from '@angular/material/dialog';
import { AppService } from '../../services/app.service';
import { TourGuideDialogComponent } from '../../tour-guide-dialog/tour-guide-dialog.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatDialogComponent } from '../../mat-dialog/mat-dialog.component';
import {
  ChecklistDetailsCategories,
  StyleSettingsDealerImage,
  StyleSettingsResponse,
  StyleSettingTitles,
  VehicleHealthChecklestResponse,
} from '../../services/client.service';
import { DownloadPdfService } from '../../services/download-pdf.service';
import { catchError, forkJoin, of } from 'rxjs';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { VehicleWalkthroughComponent } from 'src/app/vehicle-walkthrough/vehicle-walkthrough.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import {
  ButtonModule,
  IconModule,
  StructuredListModule,
  TilesModule,
} from 'carbon-components-angular';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { VideoPlayerComponent } from 'src/app/video-player/video-player.component';
import { CarouselComponent } from 'src/app/carousel/carousel.component';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { MatSnackBarComponent } from 'src/app/mat-snack-bar/mat-snack-bar.component';

@Component({
  selector: 'app-vehicle-health-report',
  templateUrl: './vhc-home.html',
  styleUrls: ['./vhc-home.scss'],
  standalone: true,
  imports: [
    MatCardModule,
    CommonModule,
    MatIconModule,
    RouterModule,
    VehicleWalkthroughComponent,
    MatDialogModule,
    MatExpansionModule,
    VideoPlayerComponent,
    CarouselComponent,
    TilesModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatMenuModule,
    MatTooltipModule,
  ],
})
export class VhcHome implements OnInit {
  pdfReport: string = $localize`PDF report`;
  downloadPdfReport: string = $localize`Download PDF report`;
  vehicleFindings: string = $localize`Vehicle findings`;
  criticalConditionInfo: string = $localize`Please review the items that are in critical condition`;
  requiredAttentionInfo: string = $localize`Please review the items that require attention`;
  checkedAndOKInfo: string = $localize`Please review the items that are checked and Ok`;
  @ViewChild('downloadPDFTour') downloadPDFTour!: ElementRef;
  @ViewChild('criticalTour') criticalTour!: ElementRef;
  @ViewChild('attenctionRequiredTour') attenctionRequiredTour!: ElementRef;
  @ViewChild('checkedAndOkTour') checkedAndOkTour!: ElementRef;
  totalSteps: number = 6;
  tourGuideDialogWidth: number = 0;
  currentStepperPosition: number = 0;
  healthReportData: any;
  token: string = '';
  categories?: ChecklistDetailsCategories[] | [];
  dealerImageDetails: StyleSettingsDealerImage | undefined;
  pdfBase64Data: string = '';
  isPDFDataAvailable: boolean = true;
  reportResponse!: VehicleHealthChecklestResponse;
  formatedDateTime: string = '';
  siteSettings: StyleSettingsResponse | undefined;
  isWalkthroughEnabled: boolean | undefined;
  attentionRequiredCount: number = 0;
  categoriesOkCount: number = 0;
  urgentRequiredCount: number = 0;
  isAllowed = true;

  constructor(
    public dialog: MatDialog,
    public appService: AppService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: ActivatedRoute,
    private pdfService: DownloadPdfService,
        private snackBar: MatSnackBar,
        private featureFlagService: FeatureFlagService
  ) {}

ngOnInit(): void {
  if (isPlatformBrowser(this.platformId)) {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];

      this.featureFlagService.getFeatures(this.token, 'VHC-Report')
        .then(allowed => {
          if (!allowed) {
            this.isAllowed = false;
            this.snackBar.openFromComponent(MatSnackBarComponent, {
              data: `The feature "Vehicle Health Check Report" is currently not enabled in MW Admin Portal - Feature Management. Please contact support for more information.`,
              duration: 10000,
              verticalPosition: 'bottom',
              horizontalPosition: 'center',
            });
            return;
          }

          forkJoin({
            vhcReport: this.appService.getHealthCheckReport(this.token),
            siteSettings: this.appService.getStyleSettings(this.token).pipe(
              catchError(() => {
                return of(null);
              })
            ),
          }).subscribe({
            next: (results: any) => {
              if (results.vhcReport) {
                this.reportResponse = results.vhcReport;
                if (this.reportResponse.submittedDate) {
                  this.formatedDateTime = this.formatDate(this.reportResponse.submittedDate);
                }

                const checkpointcount = this.countCheckpointsByWalkthrough(this.reportResponse);
                this.attentionRequiredCount = checkpointcount.attentionRequiredCount;
                this.categoriesOkCount = checkpointcount.categoriesOkCount;
                this.urgentRequiredCount = checkpointcount.urgentRequiredCount;
              }

              if (results.siteSettings) {
                this.siteSettings = results.siteSettings;
                this.dealerImageDetails = results.siteSettings.dealerImage;
              }

              const selectedLanguage = localStorage.getItem('lang');
              const tourGuide = sessionStorage.getItem('tourGuide');
              if (tourGuide !== 'true' && results.vhcReport) {
                if (selectedLanguage == null) {
                  const dialogRef = this.dialog.open(MatDialogComponent, {
                    data: { type: 'LanguageDialog' },
                  });
                  dialogRef.afterClosed().subscribe(() => {
                    this.welcomeDialog(this.reportResponse.order?.customer?.name);
                  });
                } else {
                  this.appService.setDefaultLanguage();
                  this.welcomeDialog(this.reportResponse.order?.customer?.name);
                }
              }
            },
          });

          this.getChecklistReport(this.token);
        })
        .catch(() => {
          this.isAllowed = false;
        });
    });

    this.appService.tourGuideStepPosition$.subscribe((position: number) => {
      if (position !== undefined) {
        this.currentStepperPosition = position;
      }
      if (position > 0) {
        let targetElementRect;
        const dialogConfig = new MatDialogConfig();
        if (position === 1) {
          this.appService.languaTourGuide('vhr');
        } else if (position === 2) {
          targetElementRect = this.downloadPDFTour.nativeElement.getBoundingClientRect();
          this.downloadPDFTour.nativeElement.classList.add('tour-dialog-indication');
          dialogConfig.data = {
            title: this.pdfReport,
            desciption: this.downloadPdfReport,
            stepCount: 2,
            totalSteps: this.totalSteps,
            position: targetElementRect,
          };
          this.startTour(dialogConfig);
        } else if (position === 3) {
          targetElementRect = this.criticalTour.nativeElement.getBoundingClientRect();
          this.criticalTour.nativeElement.classList.add('tour-dialog-indication');
          dialogConfig.data = {
            title: this.vehicleFindings,
            desciption: this.criticalConditionInfo,
            stepCount: 3,
            totalSteps: this.totalSteps,
            position: targetElementRect,
          };
          this.startTour(dialogConfig);
        } else if (position === 4) {
          targetElementRect = this.attenctionRequiredTour.nativeElement.getBoundingClientRect();
          this.attenctionRequiredTour.nativeElement.classList.add('tour-dialog-indication');
          dialogConfig.data = {
            title: this.vehicleFindings,
            desciption: this.requiredAttentionInfo,
            stepCount: 4,
            totalSteps: this.totalSteps,
            position: targetElementRect,
          };
          this.startTour(dialogConfig);
        } else if (position === 5) {
          targetElementRect = this.checkedAndOkTour.nativeElement.getBoundingClientRect();
          this.checkedAndOkTour.nativeElement.classList.add('tour-dialog-indication');
          dialogConfig.data = {
            title: this.vehicleFindings,
            desciption: this.checkedAndOKInfo,
            stepCount: 5,
            totalSteps: this.totalSteps,
            position: targetElementRect,
          };
          this.startTour(dialogConfig);
        } else if (position === 6) {
          this.appService.navigationTourGuide('vhr');
        }
      }
    });
  }
}


  welcomeDialog(customerName: string | undefined) {
    const title = this.siteSettings?.titles?.find(
      (title: StyleSettingTitles) => {
        return (
          title.page === 'VhcReport' &&
          title.type === 'Welcome' &&
          title.content
        );
      }
    );
    const Content =
      title && title.content
        ? this.appService.convertToHtml(title.content)
        : null;
    const dialogRef = this.dialog.open(MatDialogComponent, {
      data: {
        type: 'VHCReportWelcomeDialog',
        customerName: customerName,
        content: Content,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      sessionStorage.setItem('tourGuide', 'true');
      if (result) {
        this.appService.tourGuideStepPosition(1);
      }
    });
  }

  formatDate(dateString: string) {
    return this.appService.formatDate(dateString);
  }

  downloadPDF() {
    if (this.pdfBase64Data) {
      this.pdfService.downloadPdf(
        this.pdfBase64Data,
        'Vehicle-Health-Check-Report.pdf',
        'application/pdf'
      );
    } else {
      this.isPDFDataAvailable = false;
    }
  }

  getChecklistReport(token: string) {
    this.appService.getPDFReport(token)?.subscribe((data: string) => {
      this.pdfBase64Data = data;
      this.isPDFDataAvailable = true;
    });
  }

  startTour(dialogConfig: MatDialogConfig) {
    let screenInnerHeight;
    if (isPlatformBrowser(this.platformId)) {
      screenInnerHeight = window.innerHeight;
    } else {
      // Handle non-browser environments (e.g., SSR) gracefully
      screenInnerHeight = 0;
    }
    if (screenInnerHeight > dialogConfig.data.position.bottom) {
      if (screenInnerHeight - dialogConfig.data.position.bottom > 200) {
        dialogConfig.position = {
          top: `${dialogConfig.data.position.bottom + 5}px`,
          left: `${dialogConfig.data.position.right - 270}px`,
        };
      } else {
        dialogConfig.position = {
          top: `${dialogConfig.data.position.bottom - 200}px`,
          left: `${dialogConfig.data.position.right - 270}px`,
        };
      }
    } else {
      window.scroll({
        top: dialogConfig.data.position.bottom,
        behavior: 'smooth',
      });
      dialogConfig.position = {
        top: `${screenInnerHeight - dialogConfig.data.position.height - 210}px`,
        left: `${dialogConfig.data.position.right - 270}px`,
      };
    }

    setTimeout(() => {
      const dialogRef = this.dialog.open(
        TourGuideDialogComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        this.downloadPDFTour.nativeElement.classList.remove(
          'tour-dialog-indication'
        );
        this.criticalTour.nativeElement.classList.remove(
          'tour-dialog-indication'
        );
        this.attenctionRequiredTour.nativeElement.classList.remove(
          'tour-dialog-indication'
        );
        this.checkedAndOkTour.nativeElement.classList.remove(
          'tour-dialog-indication'
        );
        this.appService.tourGuideStepPosition(result);
      });
    }, 200);
  }

  @HostListener('window:orientationchange')
  onResize(event?: Event) {
    this.dialog.closeAll();
    if (isPlatformBrowser(this.platformId)) {
      this.tourGuideDialog(window.innerWidth);
    } else {
      this.tourGuideDialog(0);
    }

    setTimeout(() => {
      this.appService.tourGuideStepPosition(this.currentStepperPosition);
    }, 100);
  }

  tourGuideDialog(screenWidth: number) {
    if (screenWidth < 600) {
      this.tourGuideDialogWidth = 275;
    } else if (screenWidth >= 600 && screenWidth < 900) {
      this.tourGuideDialogWidth = 348;
    } else if (screenWidth >= 900 && screenWidth < 1280) {
      this.tourGuideDialogWidth = 400;
    } else {
      this.tourGuideDialogWidth = 0;
    }
  }

  getWalkthroughEnableCategory(
    categories?: ChecklistDetailsCategories[]
  ): ChecklistDetailsCategories[] {
    const filteredCategories: ChecklistDetailsCategories[] = [];
    if (categories) {
      for (const category of categories) {
        if (
          category.checkpoints?.some(
            (checkpoint) => checkpoint.isWalkthroughEnabled === true
          )
        ) {
          filteredCategories.push(category);
        }
      }
    }
    return filteredCategories;
  }

  getWalkthroughFilteredCategories(
    response: VehicleHealthChecklestResponse | undefined
  ): ChecklistDetailsCategories[] {
    if (!response) return [];
    const allFilteredCategories: ChecklistDetailsCategories[] = [];

    const categoriesOk = this.getWalkthroughEnableCategory(
      response.categoriesOk?.categories
    );
    for (const category of categoriesOk) {
      allFilteredCategories.push(category);
    }

    const attentionRequired = this.getWalkthroughEnableCategory(
      response.attentionRequired?.categories
    );
    for (const category of attentionRequired) {
      allFilteredCategories.push(category);
    }

    const urgentRequired = this.getWalkthroughEnableCategory(
      response.urgentRequired?.categories
    );
    for (const category of urgentRequired) {
      allFilteredCategories.push(category);
    }
    return allFilteredCategories;
  }

  countCheckpoints(categories: ChecklistDetailsCategories[]): number {
    return categories.reduce((count, category) => {
      return (
        count +
        (category?.checkpoints?.reduce((checkpointCount, checkpoint) => {
          return !checkpoint.isWalkthroughEnabled
            ? checkpointCount + 1
            : checkpointCount;
        }, 0) || 0)
      );
    }, 0);
  }

  countCheckpointsByWalkthrough(data: VehicleHealthChecklestResponse) {
    const attentionRequiredCount = this.countCheckpoints(
      data.attentionRequired?.categories || []
    );
    const categoriesOkCount = this.countCheckpoints(
      data.categoriesOk?.categories || []
    );
    const urgentRequiredCount = this.countCheckpoints(
      data.urgentRequired?.categories || []
    );
    return { attentionRequiredCount, categoriesOkCount, urgentRequiredCount };
  }
}
